<template>
  <crud-editor
    ref="editor"
    :definition="definition"
    :fetch-by-id="fetchById"
    :fetch-on-create="true"
    :return-to="returnTo"
    :is-edit="false"
    :auto-generated-id="false"
    :save="saveData"
    :item-type="entity"
    :page-loading="loading"
    :get-layout="layout"
    :inject-form-values="injectFormValues"
    :show-save-and-close-button="false"
    :show-save-and-next-button="false"
    prevent-default
    @childValue="handleChildValue"
  />
</template>

<script>
import CrudEditor from '@/components/crud/TabbedEditor';
import formMixin from './form-mixin';
import { getCreateLayoutDefinition } from './form.js';

export default {
  components: {
    CrudEditor
  },
  mixins: [formMixin],
  data: () => ({
    layout: getCreateLayoutDefinition
  }),
  computed: {
    loading() {
      return this.$store.getters[this.entityStore + '/isLoading'];
    }
  },
  methods: {
    fetchById(id) {
      return this.$store.dispatch(this.entityStore + '/getItem', { selector: { id } }).then(item => {
        // Reset fields to force the user to re-enter the current return reason.
        item.returnCauseID = null;
        item.returnType = null;
        item.returnReasonID = null;
        return this.createFormDataFromItem(this, item, true);
      });
    },
    saveData(form) {
      if (form.deliverAtHomeYN && (!form.consumerAddress || !form.consumerAddress.countryID)) {
        this.$store.dispatch('notify/error', { message: this.$i18n.t('validation.countryRequiredForDelivery') });
        return;
      }
      const item = this.createItemFromFormData(this, form, true);
      this.$store
        .dispatch('orderLine/createReturnOrderLine', item)
        .then(data => {
          this.$router.push({ name: 'EditOrderLine', params: { id: data } });
        })
        .catch(() => {
          this.$store.dispatch('notify/error', { message: this.$i18n.t('error.general_request') });
        });
    }
  }
};
</script>
